<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CreateBtn v-if="$policy('tag').create" class="mfe-2"/>
            <FilterIt class="mfe-2" />
            <SortIt class="mr-auto" />
        </CCol>
    </CRow>

    <Table class="mt-2" />

    <CModal v-if="createModal.show" :show.sync="createModal.show">
        <template #header-wrapper>
            <div></div>
        </template>

        create tag

        <template #footer-wrapper>
            <div></div>
        </template>
    </CModal>
</CContainer>
</template>

<script>
import { FilterIt, Table, SortIt } from './partials'

export default {
    name: 'List',

    components: {
        FilterIt,
        SortIt,
        Table,
    },

    data() {
        return {
            createModal: {
                show: false,
                item: {}
            }
        }
    }
}
</script>
